
import PaneContainer from '@/components/panes/PaneContainer.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'RegistredMaterials',
  components: { PaneContainer },
})
